const DetectBrowser = {
	/** @description Initialize DetectBrowser script */
	init: function() {
		const isSafari = /^((?!chrome|chromium|android).)*safari/i.test(navigator.userAgent) && !navigator.userAgent.includes('CriOS'); // exclude Chrome on iO

		if (isSafari) {
			document.body.classList.add('is-safari');
		}
	}
};

export default DetectBrowser;
